import { classes } from "@shared/api/services";
import { useQuery } from "@tanstack/react-query"

export const useUpcomingAppointments = () => {
    return useQuery({
        queryKey: ['upcoming-appointments'],
        queryFn: () => classes.getUpcomingClasses(),
        select: (data) => data.data
    });
};